<template>
  <div>
    <el-tabs v-model="type" @tab-click="tabChange">
      <el-tab-pane label="汇总" name="total"/>
      <el-tab-pane label="详情" name="detail"/>
    </el-tabs>
    <el-card v-show="type == 'total'">
      <el-select v-model="totalWalletType" @change="queryTotalData" size="mini" class="wallet-search">
        <el-option
          v-for="(item, index) in totalWalletTypes"
          :key="index"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-input
        v-model="searchInput"
        size="mini"
        class="search"
        placeholder="输入币种搜索"
      ></el-input>
      <el-select v-model="platform" @change="queryTotalData" size="mini" class="platform-search">
        <el-option
          :key="true"
          :value="true"
          label="非平台账户"
        >非平台账户</el-option>
        <el-option
          :key="false"
          :value="false"
          label="平台账户"
        >平台账户</el-option>
      </el-select>
      <el-date-picker
        v-model="totalDateVal"
        type="date"
        size="mini"
        @change="queryTotalData"
        class="pick-date"
      ></el-date-picker>
      <el-time-picker
        v-model="totalTimeVal"
        size="mini"
        @change="queryTotalData"
        class="pick-time"
      ></el-time-picker>
      <el-table v-if="tableAble" :data="summaryData">
        <el-table-column label="账户类型">
          <template slot-scope="scope">{{scope.row.walletType | wallets }}</template>
        </el-table-column>
        <el-table-column label="币种" prop="coinType"/>
        <el-table-column label="可用余额" prop="coinAmount"/>
        <el-table-column label="冻结余额" prop="coinFroze"/>
        <el-table-column label="持仓人数" prop="person"/>
        <el-table-column label="业务资产" prop="businessAmount"/>
        <el-table-column label="解锁中资产" prop="unlockingAmount"/>
        <el-table-column label="快照时间">
          <template slot-scope="scope">{{
            scope.row.snapshotTime.replace("T", " ")
          }}</template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card v-show="type == 'detail'">
      <el-select v-model="walletType" size="mini" class="wallet-search">
        <el-option
          v-for="(item, index) in walletTypes"
          :key="index"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-input
        v-model="coinType"
        size="mini"
        class="search"
        placeholder="输入币种搜索"
      ></el-input>
      <el-select v-model="includePlatform" size="mini" class="platform-search">
        <el-option
          :key="true"
          :value="true"
          label="含平台账户"
        >含平台账户</el-option>
        <el-option
          :key="false"
          :value="false"
          label="不含平台账户"
        >不含平台账户</el-option>
      </el-select>
      <el-date-picker
        v-model="detailDateVal"
        type="date"
        size="mini"
        class="pick-date"
      ></el-date-picker>
      <el-time-picker
        v-model="detailTimeVal"
        size="mini"
        class="pick-time"
      ></el-time-picker>
      <el-input
        v-model="size"
        size="mini"
        class="search size-search"
        placeholder="输入查询条数"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryDetailData()"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="detailBalances">
        <el-table-column label="账户类型">
          <template slot-scope="scope">{{
            scope.row.walletType | wallets
          }}</template>
        </el-table-column>
        <el-table-column label="币种" prop="coinType"></el-table-column>
        <el-table-column label="可用余额" prop="coinAmount"></el-table-column>
        <el-table-column label="冻结余额" prop="coinFroze"></el-table-column>
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="快照时间">
          <template slot-scope="scope">{{
            scope.row.snapshotTime.replace("T", " ")
          }}</template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import "../store.js";
import { WALLET_TYPES } from "../../../common/constant";
import { mapState, mapActions } from "vuex";
import { formatTable } from "../../../common/tools.js";
let supportWallets = [];
for (var i in WALLET_TYPES) {
  supportWallets.push({
    label: WALLET_TYPES[i],
    value: i,
  });
}
export default {
  name: "dataCenterBalance",
  data() {
    return {
      type: "total",
      searchInput: "",
      platform: true,
      totalDateVal: new Date(),
      totalTimeVal: new Date(),
      walletTypes: supportWallets,
      totalWalletType: "WALLET",
      walletType: "WALLET",
      coinType: "BTC",
      includePlatform: false,
      detailDateVal: new Date(),
      detailTimeVal: new Date(),
      size: 50,
      summaryData: []
    };
  },
  methods: {
    ...mapActions("dataCenter", [
      "getAllCoins",
      "getBalanceBySnapshootTime",
      "getBalanceNow",
    ]),
    queryTotalData() {
      let q = {
        platform: this.platform,
        walletType: this.totalWalletType
      };
      if (this.totalDateVal) {
        q.snapshootTime = this.totalDateVal;
        if (this.totalTimeVal) {
          q.snapshootTime.setHours(this.totalTimeVal.getHours());
          q.snapshootTime.setMinutes(this.totalTimeVal.getMinutes());
          q.snapshootTime.setSeconds(this.totalTimeVal.getSeconds());
        }
        q.snapshootTime = q.snapshootTime.getTime();
      }
      this.getBalanceBySnapshootTime(q);
    },
    queryDetailData() {
      let q = {
        includePlatform: this.includePlatform,
        coinType: this.coinType,
        size: this.size,
        walletType: this.walletType,
      };
      if (this.detailDateVal) {
        q.snapshootTime = this.detailDateVal;
        if (this.detailTimeVal) {
          q.snapshootTime.setHours(this.detailTimeVal.getHours());
          q.snapshootTime.setMinutes(this.detailTimeVal.getMinutes());
          q.snapshootTime.setSeconds(this.detailTimeVal.getSeconds());
        }
        q.snapshootTime = q.snapshootTime.getTime();
      }
      this.getBalanceNow(q);
    },
    tabChange() {
      if (this.type == "detail") {
        this.queryDetailData();
      } else {
        this.queryTotalData();
      }
    }
  },
  computed: {
    ...mapState("dataCenter", ["totalBalances", "allCoins", "detailBalances", "tableAble"]),
    totalWalletTypes() {
      let re = [];
      this.walletTypes.forEach((v, i, a) => {
        if(v.value != "CONTRACT") re.push(v);
      });
      return re;
    },
    showTotalData() {
      let re = [];
      this.summaryData = [];
      if (this.searchInput) {
        re = this.totalBalances.filter((v, i, a) => {
          return (
            v.coinType.toLowerCase().indexOf(this.searchInput.toLowerCase()) != -1
          );
        });
      } else {
        re = this.totalBalances.slice(0);
      }
      this.summaryData = re;
    }
  },
  watch: {
    showTotalData() {
      formatTable();
    },
    detailBalances() {
      formatTable();
    }
  },
  mounted() {
    this.queryTotalData();
  },
};
</script>
<style scoped>
.search {
  width: 160px;
  margin-bottom: 20px;
}
.swt {
  margin: 0px 40px;
}
.pick-date,
.pick-time {
  width: 160px;
  margin-right: 10px;
}
.wallet-search,.size-search {
  margin-right: 10px;
}
.platform-search {
  margin: 0px 10px;
}
</style>
